import { type NodeRenderer } from '@contentful/rich-text-react-renderer'
import React from 'react'

export const documentHeading1TransactionalPage: NodeRenderer = (
  node,
  children
) => <h1 className="mb-2 text-[56px]/[68px] font-normal">{children}</h1>
